import { ko } from 'date-fns/locale/ko';
import { useEffect, useRef, useState } from 'react';
import { registerLocale } from 'react-datepicker';
import { useSearchParams } from 'react-router-dom';
import { getPAIAC020, postPAIAC010 } from '../../../services/Api';
import ApplyItem from '../../../shared/components/ApplyItem';
import Pagination from '../../../shared/components/Pagination';
import SearchDateRange from '../../../shared/components/SearchDateRange';
import SideNav from '../../../shared/components/SideNav';

import moment from 'moment';
import 'react-datepicker/dist/react-datepicker.css';
import { formatDate, formatDateTextKo, getResultText, handlePrint } from '../../../utils';
registerLocale('ko', ko);

const PAIAC010 = () => {
    const [searchParams, setSearchParams] = useSearchParams();
    const page = Number(searchParams.get('page')) || 1;
    const [pages, setPages] = useState({});
    const [data, setData] = useState([]);
    const [statistic, setStatistic] = useState({});
    const [popupActive, setPopupActive] = useState(false);
    const [applicantInfo, setApplicantInfo] = useState({});
    const [applyHistory, setApplyHistory] = useState([]);
    const printRef = useRef();

    const [startDate, setStartDate] = useState(null);
    const [endDate, setEndDate] = useState(null);

    const fetchList = async () => {
        const startDateFormat = startDate ? moment(startDate).format('YYYY-MM-DD') : null;
        const endDateFormat = endDate ? moment(endDate).format('YYYY-MM-DD') : null;

        const { data } = await postPAIAC010({
            page,
            startDate: startDateFormat,
            endDate: endDateFormat,
        });

        setData(data.data.list || []);
        setStatistic(data.data.statistic[0] || {});
        setPages(data.info || {});
    };

    const refreshData = async () => {
        try {
            const startDateFormat = startDate ? moment(startDate).format('YYYY-MM-DD') : null;
            const endDateFormat = endDate ? moment(endDate).format('YYYY-MM-DD') : null;

            const { data } = await postPAIAC010({
                page,
                startDate: startDateFormat,
                endDate: endDateFormat,
            });

            setData(data.data.list || []);
            setStatistic(data.data.statistic[0] || {});
            setPages(data.info || {});
        } catch (error) {
            console.error(error);
        }
    };

    const getListData = (startDate, endDate) => {
        const startDateFormat = startDate ? moment(startDate).format('YYYY-MM-DD') : null;
        const endDateFormat = endDate ? moment(endDate).format('YYYY-MM-DD') : null;
        postPAIAC010({ page, startDate: startDateFormat, endDate: endDateFormat })
            .then(({ data }) => {
                setData(data.data.list || []);
                setStatistic(data.data.statistic[0] || {});
                setPages(data.info || {});
            })
            .catch((error) => console.error(error));
    };

    const handleSearchDateRange = (sDate, eDate) => {
        setStartDate(sDate);
        setEndDate(eDate);
        setSearchParams({ page: 1 });
    };

    const getListPrint = () => {
        setPopupActive(true);

        getPAIAC020().then(({ data }) => {
            setApplicantInfo(data.applicantInfo);

            // Filter applyHistory theo startDate/endDate
            let filteredHistory = data.applyHistory || [];

            if (startDate || endDate) {
                filteredHistory = filteredHistory.filter(item => {
                    const applyDate = moment(item.applyDate);

                    if (startDate && endDate) {
                        return applyDate.isBetween(
                            moment(startDate).startOf('day'),
                            moment(endDate).endOf('day'),
                            null,
                            '[]'
                        );
                    } else if (startDate) {
                        return applyDate.isSameOrAfter(moment(startDate).startOf('day'));
                    } else if (endDate) {
                        return applyDate.isSameOrBefore(moment(endDate).endOf('day'));
                    }
                    return true;
                });
            }

            setApplyHistory(filteredHistory);
        });
    };
    useEffect(() => {
        fetchList();
    }, [page, startDate, endDate]);

    return (
        <>
            <div id="content" className="sub-page">
                <div className="container">
                    <div id="top-sub-page">
                        <SideNav />
                        <div className="resume">
                            <div className="resume__inner">
                                <h3 className="resume__tit">
                                    지원 현황{' '}
                                    <span>
                                        * 이력서 공개 기간은 별도 제한이 없으며, 비공개를 원하시는 선생님께서는 별도로 비공개 설정 부탁드립니다.
                                    </span>
                                </h3>
                                <div className="rsm-stt">
                                    <ul className="rsm-stt__list">
                                        <li className="rsm-stt__item">
                                            <span>지원완료</span>
                                            <div className="rsm-stt__num">{statistic.totalApply || 0}</div>
                                        </li>
                                        <li className="rsm-stt__item">
                                            <span>이력서 열람</span>
                                            <div className="rsm-stt__num">{statistic.reviewedNoCancel || 0}</div>
                                        </li>
                                        <li className="rsm-stt__item">
                                            <span>이력서 미열람</span>
                                            <div className="rsm-stt__num">{statistic.pendingNoCancel || 0}</div>
                                        </li>
                                        <li className="rsm-stt__item">
                                            <span>지원취소</span>
                                            <div className="rsm-stt__num">{statistic.cancelled || 0}</div>
                                        </li>
                                    </ul>
                                    <SearchDateRange
                                        handleSearchDateRange={handleSearchDateRange}
                                        setSearchParams={setSearchParams}
                                    />
                                </div>
                                <div className="rsm-mng">
                                    <div className="rsm-mng__btbx">
                                        <button
                                            type="button"
                                            id="jbsrActvBtn"
                                            className="rsm-mng__btn"
                                            onClick={getListPrint}
                                        >
                                            취업활동증명서 보기
                                        </button>
                                    </div>
                                    <div className="rsm-mng__block">
                                        <table className="rsm-stt__table">
                                            <thead>
                                                <tr>
                                                    <th>지원일</th>
                                                    <th>지원결과</th>
                                                    <th style={{ width: '120px' }}>치과명</th>
                                                    <th style={{ width: '280px' }}>지원내역</th>
                                                    <th>공고 상태</th>
                                                    <th>열람</th>
                                                    <th>관리</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {data && data?.length > 0 ? (
                                                    data?.map((item, index) => (
                                                        <ApplyItem
                                                            key={`apply_${index}`}
                                                            item={item}
                                                            type={'tr'}
                                                            onRefresh={fetchList}
                                                        />
                                                    ))
                                                ) : (
                                                    <tr>
                                                        <td colSpan={7}>데이터없습니다</td>
                                                    </tr>
                                                )}
                                            </tbody>
                                        </table>
                                        <Pagination pages={pages} />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {popupActive && (
                <div className="rsm-print" id="rsmPrintView" ref={printRef}>
                    <div className="rsm-print__inner">
                        <button
                            type="button"
                            id="rsmPrintViewClose"
                            className="rsm-print__close"
                            onClick={() => setPopupActive(false)}
                        />
                        <div className="rsm-print__container">
                            <p className="rsm-print__date">출력일 : {moment().format('YYYY년 MM월 DD일')}</p>
                            <h1 className="rsm-print__tit">취업활동 증명서</h1>
                            <dl className="rsm-print__grid">
                                <dt className="rsm-print__dt">성명 :</dt>
                                <dd className="rsm-print__dd">{applicantInfo.nameKor}</dd>
                                <dt className="rsm-print__dt">생년월일 :</dt>
                                <dd className="rsm-print__dd">
                                    {moment(applicantInfo?.residentNo, 'YYMMDD').format('YYYY년 MM월 DD일')}
                                </dd>
                                <dt className="rsm-print__dt">주소 :</dt>
                                <dd className="rsm-print__dd">{applicantInfo.address}</dd>
                                <dt className="rsm-print__dt">연락처 :</dt>
                                <dd className="rsm-print__dd">{applicantInfo.mobileNo}</dd>
                            </dl>
                            <h2 className="rsm-print__sbj">[ 활동현황 ]</h2>
                            <table className="rsm-print__table">
                                <thead>
                                    <tr>
                                        <th>지원일</th>
                                        <th>주소</th>
                                        <th>치과명</th>
                                        <th>연락처</th>
                                        <th>활동결과</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {applyHistory && applyHistory?.length > 0 ? (
                                        applyHistory?.map((item, index) => (
                                            <tr key={'applyHistory_' + index}>
                                                <td>{formatDate(item.applyDate)}</td>
                                                <td style={{ wordBreak: 'auto-phrase' }}>{item.bizAddrDesc}</td>
                                                <td style={{ wordBreak: 'auto-phrase' }}>{item.recCompany}</td>
                                                <td>{item.chargeTel}</td>
                                                <td>{getResultText(item.result)}</td>
                                            </tr>
                                        ))
                                    ) : (
                                        <tr>
                                            <td colSpan={5}>데이터없습니다</td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                            <p className="rsm-print__info">
                                상기 회원은{' '}
                                <b>
                                    {(applyHistory ?? []).length > 0
                                        ? `${formatDateTextKo(
                                            (applyHistory ?? [])[applyHistory.length - 1]?.applyDate,
                                        )} ~ ${formatDateTextKo((applyHistory ?? [])[0]?.applyDate)}`
                                        : ''}
                                </b>{' '}
                                까지
                                <br />
                                덴탈잡 온라인 지원시스템을 통해 위 치과에 온라인 입사지원 하였음을 증명합니다.
                            </p>
                            <div className="rsm-print__btm">
                                <img src="./images/logo.png" alt="logo" />
                            </div>
                        </div>

                        <div className="rsm-print__btbx">
                            <button
                                className="rsm-print__btn"
                                onClick={() => handlePrint(printRef, ['.rsm-print__btbx'])}
                            >
                                인쇄하기
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
};
export default PAIAC010;